<template>
    <b-modal
        no-close-on-esc
        no-close-on-backdrop
        id="logout-counter"
        centered
        hide-header
        content-class="py-3"
        @show="startTimer">
        <p class="text-center">
            Your session will expire in {{ (time / 1000) }} seconds. To continue where you left off,
            click on 'Continue' or click on logout.
        </p>
        <template slot="modal-footer">
            <b-button @click="forceLogout">Logout</b-button>
            <b-button variant="primary" @click="refreshIdleTime">Continue</b-button>
        </template>
    </b-modal>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
    name: "AutoLogoutCounter",
    data() {
        return {
            time: 30000,
            counter: null,
            count: false,
        }
    },
    methods: {
        ...mapActions("auth", ["logout"]),
        ...mapMutations("auth", ["autoLogout"]),
        refreshIdleTime () {
            this.$root.$emit('bv::hide::modal', 'logout-counter')
            this.$root.$emit("resetIdle");
            this.$root.$emit('refreshIdleTime')
            clearInterval(this.counter);
            this.time = 30000;
        },
        startTimer () {
            this.counter = setInterval(() => {
                // if (this.count) {
                    this.time -= 1000;
                    
                    if (this.time < 1) {
                        this.autoLogout(1);
                        this.$root.$emit('bv::hide::modal', 'logout-counter')
                        this.clearInterval(this.counter)
                        this.logout();
                    }
                // }
            }, 1000);
        },
        forceLogout () {
            this.$root.$emit('bv::hide::modal', 'logout-counter')
            this.clearInterval(this.counter)
            this.logout();
        },
        clearInterval (counter) {
            clearInterval(counter);
            this.count = false;
        }
    }
}
</script>
